import * as tslib_1 from "tslib";
import { Vue, Prop, Component, Model } from "vue-property-decorator";
import { Checkbox, Radio } from "@h3/antd-vue";
let CheckboxText = class CheckboxText extends Vue {
    constructor() {
        super(...arguments);
        this.hover = false;
    }
    onMouseover() {
        this.hover = true;
    }
    onMouseleave() {
        this.hover = false;
    }
    onCheckboxChange(val) {
        this.$emit('change', val);
    }
};
tslib_1.__decorate([
    Model('change')
], CheckboxText.prototype, "value", void 0);
tslib_1.__decorate([
    Prop({
        default: false
    })
], CheckboxText.prototype, "readonly", void 0);
tslib_1.__decorate([
    Prop({
        default: false
    })
], CheckboxText.prototype, "radio", void 0);
CheckboxText = tslib_1.__decorate([
    Component({
        name: "checkbox-text",
        components: {
            ACheckbox: Checkbox,
            ARadio: Radio
        }
    })
], CheckboxText);
export default CheckboxText;
